import { render, staticRenderFns } from "./AppsFeatureIntroDetails.vue?vue&type=template&id=04a1e890&scoped=true&"
import script from "./AppsFeatureIntroDetails.vue?vue&type=script&lang=js&"
export * from "./AppsFeatureIntroDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a1e890",
  null
  
)

export default component.exports